import React, { useEffect, useState, forwardRef } from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faKey, faEnvelope, faHome } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { motion } from 'framer-motion';
import login from '../assets/login.svg';
import register from '../assets/login_photo.svg';
import { UserAuth } from '../context/AuthContext';
import { db } from '../firebase';
import { setDoc, doc, serverTimestamp, collection, addDoc, updateDoc, getDoc } from 'firebase/firestore';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { getAuth, sendEmailVerification } from 'firebase/auth';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confPassword, setConfPassword] = useState('');
  const [alert, setAlert] = useState('');
  const [alertText, setAlertText] = useState('');
  const navigate = useNavigate();
  const { signIn } = UserAuth();
  const { signInWithFacebook } = UserAuth();
  const { signInWithGoogle } = UserAuth();
  const { createUser } = UserAuth();
  const [data, setData] = useState([]);
  const admin = 'ENj1jE1gioNALVIoOC0qhgsUDBI3';
  const [open, setOpen] = useState(false);
  const auth = getAuth();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'admins', admin);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [admin]);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setAlert('');
    try {
      if (email === data.email && password === data.password) {
        navigate('/adminlogin');
      } else {
        const res = await signIn(email, password);
        if (res.user.emailVerified === true) {
          const status = doc(db, 'users', res.user.uid);
          await updateDoc(status, {
            status: true,
          });
          setOpen(true);
          setAlert('Email Verified');
          setAlertText('success');
          navigate(`/${res.user.uid}/dashboard`);
        } else {
          setOpen(true);
          setAlert('Email verificarion necessary to procced');
          setAlertText('error');
        }
      }
    } catch (e) {
      setOpen(true);
      setAlert(e.message);
      setAlertText('error');
      console.log(e.message);
    }
  };
  const handleSignUpFacebook = async (e) => {
    e.preventDefault();
    setAlert('');
    try {
      const admin_image =
        'https://firebasestorage.googleapis.com/v0/b/imafeel-db.appspot.com/o/profileIcon_m8nm4pqa3q551.jpg?alt=media&token=0cf70a0d-c850-4b53-b97f-6458c0e14ff2';
      const res = await signInWithFacebook();
      setDoc(doc(db, 'users', res.user.uid), {
        email: res.user.email,
        img: res.user.photoURL,
        username: res.user.displayName,
        status: true,
        space: 1000,
        photos_nr: 0,
        timeStamp: serverTimestamp(),
      });
      await addDoc(collection(db, 'users', res.user.uid, 'notifications'), {
        from: 'Administrator',
        title: 'Welcome to IMAFEEL',
        desc: "We welcome you to the IMAFEEL aplication, you'll have 200 photos to upload with the basic one",
        img: admin_image,
        isCheck: false,
        timeStamp: serverTimestamp(),
      });

      navigate(`/${res.user.uid}/dashboard`);
    } catch (e) {
      setOpen(true);
      setAlert(e.message);
      setAlertText('error');
      console.log(e.message);
    }
  };

  const handleSignFacebook = async (e) => {
    e.preventDefault();
    setAlert('');
    try {
      const res = await signInWithFacebook();
      const status = doc(db, 'users', res.user.uid);
      await updateDoc(status, {
        status: true,
      });

      navigate(`/${res.user.uid}/dashboard`);
    } catch (e) {
      setOpen(true);
      setAlert('No account found');
      setAlertText('error');
      console.log(e.message);
    }
  };

  const handleSignUpGoogle = async (e) => {
    e.preventDefault();
    setAlert('');

    try {
      const admin_image =
        'https://firebasestorage.googleapis.com/v0/b/imafeel-db.appspot.com/o/profileIcon_m8nm4pqa3q551.jpg?alt=media&token=0cf70a0d-c850-4b53-b97f-6458c0e14ff2';
      const res = await signInWithGoogle();

      setDoc(doc(db, 'users', res.user.uid), {
        email: res.user.email,
        img: res.user.photoURL,
        username: res.user.displayName,
        status: true,
        space: 1000,
        photos_nr: 0,
        timeStamp: serverTimestamp(),
      });
      await addDoc(collection(db, 'users', res.user.uid, 'notifications'), {
        from: 'Administrator',
        title: 'Welcome to IMAFEEL',
        desc: "We welcome you to the IMAFEEL aplication, you'll have 200 photos to upload with the basic one",
        img: admin_image,
        isCheck: false,
        timeStamp: serverTimestamp(),
      });

      navigate(`/${res.user.uid}/dashboard`);
    } catch (e) {
      setOpen(true);
      setAlert(e.message);
      setAlertText('error');
      console.log(e.message);
    }
  };

  const handleSignGoogle = async (e) => {
    e.preventDefault();
    setAlert('');

    try {
      const res = await signInWithGoogle();
      const status = doc(db, 'users', res.user.uid);
      await updateDoc(status, {
        status: true,
      });

      navigate(`/${res.user.uid}/dashboard`);
    } catch (e) {
      setOpen(true);
      setAlert('No account found');
      setAlertText('error');
      console.log(e.message);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (password !== confPassword) {
      return setAlert('Passwords do not match');
    }

    try {
      const no_image =
        'https://firebasestorage.googleapis.com/v0/b/imafeel-db.appspot.com/o/no_user.svg?alt=media&token=bfe14ed7-cb09-4379-91c6-328d5c70a06c';
      const admin_image =
        'https://firebasestorage.googleapis.com/v0/b/imafeel-db.appspot.com/o/profileIcon_m8nm4pqa3q551.jpg?alt=media&token=0cf70a0d-c850-4b53-b97f-6458c0e14ff2';
      const res = await createUser(email, password);
      sendEmailVerification(auth.currentUser).then(() => {
        // Email verification sent!
        // ...
      });

      setDoc(doc(db, 'users', res.user.uid), {
        email: email,
        password: password,
        img: no_image,
        status: true,
        space: 1000,
        photos_nr: 0,
        timeStamp: serverTimestamp(),
      });
      await addDoc(collection(db, 'users', res.user.uid, 'notifications'), {
        from: 'Administrator',
        title: 'Welcome to IMAFEEL',
        desc: "We welcome you to the IMAFEEL application, you'll have 200 photos to upload with the basic one, have fun uploading photos",
        img: admin_image,
        isCheck: false,
        timeStamp: serverTimestamp(),
      });

      setOpen(true);
      setAlert('An verification email was send to your mailbox');
      setAlertText('info');
      setEmail('');
      setPassword('');
      setConfPassword('');
    } catch (e) {
      setOpen(true);
      setAlert(e.message);
      setAlertText('error');
      console.log(e.message);
    }
  };

  useEffect(() => {
    const sign_in_btn = document.querySelector('#sign-in-btn');
    const sign_up_btn = document.querySelector('#sign-up-btn');
    const container = document.querySelector('.container');

    sign_up_btn.addEventListener('click', () => {
      container.classList.add('sign-up-mode');
    });

    sign_in_btn.addEventListener('click', () => {
      container.classList.remove('sign-up-mode');
    });
  });
  return (
    <LoginStyled
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1, transition: { duration: 1, delay: 0.6 } }}
      exit={{ opacity: 0, scale: 0, transition: { duration: 0.8 } }}
    >
      <div className="container">
        <Stack spacing={2} sx={{ width: '100%' }}>
          <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={alertText} sx={{ width: '100%' }}>
              {alert}
            </Alert>
          </Snackbar>
        </Stack>
        <div className="forms-container">
          <div className="signin-signup">
            <form action="" className="sign-in-form" onSubmit={handleSignIn}>
              <h2 className="title">Sign In</h2>
              <div className="input-field">
                <div className="icon-container">
                  <StyledIcon icon={faEnvelope} />
                </div>
                <input
                  className="input-form"
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Email"
                />
              </div>
              <div className="input-field">
                <div className="icon-container">
                  <StyledIcon icon={faKey} />
                </div>
                <input
                  className="input-form"
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="Password"
                />
              </div>
              <motion.div
                whileHover={{
                  scale: 1.2,
                  transition: { duration: 0.2 },
                }}
              >
                <input type="submit" value="Login" className="btn solid" />
              </motion.div>

              <p className="social-text">Or sign in with social platforms</p>
              <div className="social-media">
                <div onClick={handleSignFacebook} className="social-icon">
                  <StyledIcon icon={faFacebookF} />
                </div>
                <div onClick={handleSignGoogle} className="social-icon">
                  <StyledIcon icon={faGoogle} />
                </div>
              </div>
              <p className="social-text">Or go to the Homepage</p>
              <div className="social-media">
                <Link to="/" className="social-icon">
                  <StyledIcon icon={faHome} />
                </Link>
              </div>
            </form>

            <form className="sign-up-form" onSubmit={handleSignUp} key="id">
              <h2 className="title">Sign Up</h2>

              <div className="input-field">
                <div className="icon-container">
                  <StyledIcon icon={faEnvelope} />
                </div>
                <input
                  className="input-form"
                  onChange={(e) => setEmail(e.target.value)}
                  type="text"
                  placeholder="Email"
                  required
                />
              </div>
              <div className="input-field">
                <div className="icon-container">
                  <StyledIcon icon={faKey} />
                </div>
                <input
                  className="input-form"
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="Password"
                  required
                />
              </div>
              <div className="input-field">
                <div className="icon-container">
                  <StyledIcon icon={faLock} />
                </div>
                <input
                  className="input-form"
                  onChange={(e) => setConfPassword(e.target.value)}
                  type="password"
                  placeholder="Confirm Password"
                  required
                />
              </div>
              <motion.div
                whileHover={{
                  scale: 1.2,
                  transition: { duration: 0.2 },
                }}
              >
                <input type="submit" value="Register" className="btn solid" />
              </motion.div>

              <p className="social-text">Or sign up with social platforms</p>
              <div className="social-media">
                <div onClick={handleSignUpFacebook} className="social-icon">
                  <StyledIcon icon={faFacebookF} />
                </div>
                <div onClick={handleSignUpGoogle} className="social-icon">
                  <StyledIcon icon={faGoogle} />
                </div>
              </div>
              <p className="social-text">Or go to the Homepage</p>
              <div className="social-media">
                <Link to="/" className="social-icon">
                  <StyledIcon icon={faHome} />
                </Link>
              </div>
            </form>
          </div>
        </div>

        <div className="panels-container">
          <div className="panel left-panel">
            <div className="content">
              <h3>New here?</h3>
              <p className="panel-text">
                If you never been here and want to make part of one of this community and register your account, to join
                us
              </p>
              <button className="btn transparent" id="sign-up-btn">
                Sign Up
              </button>
            </div>
            <img src={login} alt="" className="image" />
          </div>
          <div className="panel right-panel">
            <div className="content">
              <h3>One of us?</h3>
              <p className="panel-text">
                If you already have an account and want to begin to organize your environment, just sign in to start now
              </p>
              <button className="btn transparent" id="sign-in-btn">
                Sign In
              </button>
            </div>
            <img src={register} alt="" className="image" />
          </div>
        </div>
      </div>
    </LoginStyled>
  );
}

const LoginStyled = styled(motion.div)`
  .container {
    position: relative;
    width: 100%;
    background-color: #fff;
    min-height: 100vh;
    overflow: hidden;
  }

  .forms-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .signin-signup {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 75%;
    width: 50%;
    transition: 1s 0.4s ease-in-out;
    display: grid;
    grid-template-columns: 1fr;
    z-index: 5;
  }

  form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0rem 5rem;
    transition: all 0.2s 0.7s;
    overflow: hidden;
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  form.sign-up-form {
    opacity: 0;
    z-index: 1;
  }

  form.sign-in-form {
    z-index: 2;
  }

  .title {
    font-size: 2.2rem;
    color: #444;
    margin-bottom: 10px;
  }

  .input-field {
    max-width: 380px;
    width: 100%;
    background-color: #f0f0f0;
    margin: 10px 0;
    height: 55px;
    border-radius: 55px;
    display: grid;
    grid-template-columns: 15% 85%;
    padding: 0 0.4rem;
    position: relative;
  }

  .input-field .icon-container {
    text-align: center;
    line-height: 55px;
    color: #acacac;
    transition: 0.5s;
    font-size: 1.1rem;
  }

  .input-field input {
    background: none;
    outline: none;
    border: none;
    line-height: 1;
    font-weight: 600;
    font-size: 1.1rem;
    color: #333;
  }

  .input-field input::placeholder {
    color: #aaa;
    font-weight: 500;
  }

  .social-text {
    padding: 0.7rem 0;
    font-size: 1rem;
  }

  .social-media {
    display: flex;
    justify-content: center;
  }

  .social-icon {
    height: 46px;
    width: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.45rem;
    color: #333;
    border-radius: 50%;
    border: 1px solid #333;
    text-decoration: none;
    font-size: 1.1rem;
    transition: 0.3s;
    cursor: pointer;
  }

  .social-icon:hover {
    color: #4481eb;
    border-color: #4481eb;
  }

  .btn {
    width: 150px;
    background-color: #7199ff;
    border: none;
    outline: none;
    height: 49px;
    border-radius: 49px;
    color: #fff;
    text-transform: uppercase;
    font-weight: 600;
    margin: 10px 0;
    cursor: pointer;
    transition: 0.5s;
  }

  .btn:hover {
    background-color: #4d84e2;
  }
  .panels-container {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .container:before {
    content: '';
    position: absolute;
    height: 2000px;
    width: 2000px;
    top: -10%;
    right: 48%;
    transform: translateY(-50%);
    background-image: linear-gradient(-45deg, #7199ff 0%, #04befe 100%);
    transition: 1.8s ease-in-out;
    border-radius: 50%;
    z-index: 6;
  }

  .image {
    width: 100%;
    transition: transform 1.1s ease-in-out;
    transition-delay: 0.4s;
  }

  .panel {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-around;
    text-align: center;
    z-index: 6;
  }

  .left-panel {
    pointer-events: all;
    padding: 3rem 17% 2rem 12%;
  }

  .right-panel {
    pointer-events: none;
    padding: 3rem 12% 2rem 17%;
  }

  .panel .content {
    color: #fff;
    transition: transform 0.9s ease-in-out;
    transition-delay: 0.6s;
  }

  .panel h3 {
    font-weight: 600;
    line-height: 1;
    font-size: 1.5rem;
  }

  .panel p {
    font-size: 0.95rem;
    padding: 0.7rem 0;
    color: #fff;
  }

  .btn.transparent {
    margin: 0;
    background: none;
    border: 2px solid #fff;
    width: 130px;
    height: 41px;
    font-weight: 600;
    font-size: 0.8rem;
  }

  .right-panel .image,
  .right-panel .content {
    transform: translateX(800px);
  }

  /* ANIMATION */

  .container.sign-up-mode:before {
    transform: translate(100%, -50%);
    right: 52%;
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateX(-800px);
  }

  .container.sign-up-mode .signin-signup {
    left: 25%;
  }

  .container.sign-up-mode form.sign-up-form {
    opacity: 1;
    z-index: 2;
  }

  .container.sign-up-mode form.sign-in-form {
    opacity: 0;
    z-index: 1;
  }

  .container.sign-up-mode .right-panel .image,
  .container.sign-up-mode .right-panel .content {
    transform: translateX(0%);
  }

  .container.sign-up-mode .left-panel {
    pointer-events: none;
  }

  .container.sign-up-mode .right-panel {
    pointer-events: all;
  }

  @media (max-width: 956px) {
    .container {
      min-height: 800px;
      height: 100vh;
    }
    .signin-signup {
      width: 100%;
      top: 95%;
      transform: translate(-50%, -100%);
      transition: 1s 0.8s ease-in-out;
    }

    .signin-signup,
    .container.sign-up-mode .signin-signup {
      left: 50%;
    }

    .panels-container {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 2fr 1fr;
    }

    .panel {
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 2.5rem 8%;
      grid-column: 1 / 2;
    }

    .right-panel {
      grid-row: 3 / 4;
    }

    .left-panel {
      grid-row: 1 / 2;
    }

    .image {
      width: 200px;
      transition: transform 0.9s ease-in-out;
      transition-delay: 0.6s;
    }

    .panel .content {
      padding-right: 15%;
      transition: transform 0.9s ease-in-out;
      transition-delay: 0.8s;
    }

    .btn.transparent {
      width: 110px;
      height: 35px;
      font-size: 0.7rem;
    }

    .container:before {
      width: 1500px;
      height: 1500px;
      transform: translateX(-50%);
      left: 30%;
      bottom: 68%;
      right: initial;
      top: initial;
      transition: 2s ease-in-out;
    }

    .container.sign-up-mode:before {
      transform: translate(-50%, 102%);
      bottom: 32%;
      right: initial;
    }

    .container.sign-up-mode .left-panel .image,
    .container.sign-up-mode .left-panel .content {
      transform: translateY(-300px);
    }

    .container.sign-up-mode .right-panel .image,
    .container.sign-up-mode .right-panel .content {
      transform: translateY(0px);
    }

    .right-panel .image,
    .right-panel .content {
      transform: translateY(300px);
    }

    .container.sign-up-mode .signin-signup {
      top: 5%;
      transform: translate(-50%, 0);
    }
  }

  @media (max-width: 716px) {
    form {
      padding: 0 1.5rem;
    }

    .image {
      display: none;
    }
    .panel .content {
      padding: 0.5rem 1rem;
    }
    .container {
      padding: 1.5rem;
    }

    .container:before {
      bottom: 72%;
      left: 50%;
    }

    .container.sign-up-mode:before {
      bottom: 30%;
      left: 50%;
    }
    .panel h3 {
      font-size: 1.2rem;
    }

    .panel p {
      font-size: 0.7rem;
      padding: 0.5rem 0;
    }
  }
`;

const StyledIcon = styled(FontAwesomeIcon)``;

export default Login;
